module.exports = __webpack_public_path__ + "img/report.7248c93b.svg";